import { IPublicClientApplication } from "@azure/msal-browser";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { loginRequest } from "utils/authUtils";

const login = (instance: IPublicClientApplication): void => {
  instance
    .loginRedirect({
      redirectUri: "/my-insights",
      ...loginRequest,
    })
    .catch((error: unknown) => {
      console.error("Login failed", error);
    });
};

const UnauthenticatedSilentLogin = ({
  instance,
}: {
  instance: IPublicClientApplication;
}): null => {
  useEffect(() => {
    login(instance);
  }, [instance]);

  return null;
};

const SilentLogin = (): JSX.Element => {
  const { instance } = useMsal();

  return (
    <>
      <AuthenticatedTemplate>
        <Navigate to="/my-insights" replace />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <UnauthenticatedSilentLogin instance={instance} />
      </UnauthenticatedTemplate>
    </>
  );
};

export default SilentLogin;
